import React from "react";
import Head from "next/head";

import PartnersMain from "@/components/partners/partners-main";
import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

const PartnersPage = () => {
  return (
    <>
      <Head>
        <title>{seoData.PARTNERS.title}</title>
        <SeoMetaData data={seoData.PARTNERS} />
      </Head>

      <PartnersMain />
    </>
  );
};

export default PartnersPage;
